import { ListStyleMarker } from "@mgdx/ui/components/ListStyleMarker";
import { GatsbyLink, GatsbyLinkProps } from "@mgdx-libs/link";
import { cx } from "cva";
import React from "react";

import { SubtleButtonProps, variants } from ".";
import * as styles from "./SubtleButton.module.css";

export const SubtleButtonBulletLink = ({
  className,
  children,
  align,
  radius,
  disabled,
  ...props
}: Readonly<SubtleButtonProps & Omit<GatsbyLinkProps<EmptyObject>, "ref">>) => (
  <GatsbyLink aria-disabled={disabled} className={cx(styles.bullet, variants({ align, radius }), className)} {...props}>
    <span className="flex items-start">
      <ListStyleMarker className="shrink-0" />
      {children}
    </span>
  </GatsbyLink>
);
